import { render } from "./Profile-Doctor.vue?vue&type=template&id=63a8b210&ts=true"
import script from "./Profile-Doctor.vue?vue&type=script&lang=ts"
export * from "./Profile-Doctor.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/poct.nikted.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__